export class HasDynamicData {

    // Properties
    public DynamicProperties : {[key: string]: string}

    // Constructor
    constructor() {
        if (!this.DynamicProperties) {
            this.DynamicProperties = {};
        }
    }

    // Methods
    public createAccessorsAndMutators(dynamicProperties?: string[]) {
        if (!this.DynamicProperties) {
            this.DynamicProperties = {};
        }
        if (dynamicProperties) {
            const newDynamicProperties: {[key: string]: string} = {};
            dynamicProperties.forEach(dynamicProperty => {
                newDynamicProperties[dynamicProperty] = this.DynamicProperties[dynamicProperty];
            });
            this.DynamicProperties = newDynamicProperties;
        }
        const dynamicKeys = Object.keys(this.DynamicProperties);
        dynamicKeys.forEach(dynamicKey => {
            Object.defineProperty(
                this,
                dynamicKey,
                {
                    get() {
                        return this.DynamicProperties[dynamicKey];
                    },
                    set(value: any) {
                        this.DynamicProperties[dynamicKey] = value;
                    },
                    configurable: true
                }
            );
        });
    }
}